<template>
  <div class="minbox">
    <el-menu
      ref="menu"
      router
      class="el-menu-vertical-demo l_menu"
      :collapse="isCollapse"
      background-color="#f3f3f3"
      text-color="#000000"
      :unique-opened="true"
      style="border-right: 0"
      :collapse-transition="true"
      :default-active="active"
    >
      <sidebar-item
        :class="`driver-item-${route.code}`"
        v-for="route in routers"
        :key="route.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
  </div>
</template>

<script>
import Menu from './menus' // 引进菜单模板
import SidebarItem from './menus' // 引进菜单模板
import bus from '@/utils/bus.js'

export default {
  props: {
    collapse: {
      type: Boolean,
      value: false
    }
  },
  data () {
    return {
      isCollapse: false, // 菜单展开功能
      logShow: true,
      active: '',
      unCollapse: {
        width: '220px'
      }
    }
  },
  components: {
    Menu,
    SidebarItem
  },
  computed: {
    routers () {
      let menu = this.$store.state.CURRENT_SYSTEM_MENU || []
      if (!Array.isArray(menu)) return []
      // 深拷贝避免修改 vuex 中的原始数据
      menu = JSON.parse(JSON.stringify(menu))

      const userType = this.$store.state.accountUserType
        || (this.$store.state.userInfo && this.$store.state.userInfo.user && this.$store.state.userInfo.user.userType)
        || localStorage.getItem('userType')
        || 'ENTERPRISE'
      const user = this.$store.state.userInfo && this.$store.state.userInfo.user
      // 兼容 snake_case（@SnakeCaseResponse 序列化）和 camelCase
      const rawCustomerId = user && user.defaultCustomerId
      const customerId = rawCustomerId ? String(rawCustomerId) : ''
      const isPlatformCustomer = customerId === '1'

      // 除了 root 其他的都不可以看到访问资源
      if (user && user.id !== 1) {
        menu.forEach(item => {
          if (item.code === 'sys' && Array.isArray(item.sub)) {
            item.sub = item.sub.filter(opt => opt.code !== 'resource')
          }
        })
      }

      // 按用户类型过滤菜单（与后端 filterMenusByUserType 保持一致，前端安全防护层）
      if (userType === 'PERSONAL') {
        // 个人账号：隐藏 UAM(account) 和 System(sys)
        menu = menu.filter(item => item.code !== 'account' && item.code !== 'sys')
      } else if (userType === 'ENTERPRISE') {
        if (!isPlatformCustomer) {
          // 企业身份账号（非平台）：隐藏 UAM 和 System
          menu = menu.filter(item => item.code !== 'account' && item.code !== 'sys')
        } else {
          // 平台企业用户：隐藏 System
          menu = menu.filter(item => item.code !== 'sys')
        }
      } else if (userType === 'ENTERPRISE_ROOT') {
        if (!isPlatformCustomer) {
          // 企业初始账号（非平台）：隐藏 System，UAM 只保留 user/role/scope/security
          menu = menu.filter(item => item.code !== 'sys')
          menu.forEach(item => {
            if (item.code === 'account' && Array.isArray(item.sub)) {
              item.sub = item.sub.filter(sub =>
                sub.code === 'user' || sub.code === 'role' ||
                sub.code === 'scope' || sub.code === 'security')
            }
          })
        }
        // 平台 Root：全部可见
      }
      // 过滤掉没有子菜单的一级菜单
      return menu.filter(item => !Array.isArray(item.sub) || item.sub.length > 0)
    }
  },
  mounted () {
    // 暴露menu的方法到state
    this.$store.state.menu = {
      open: this.$refs.menu.open
    }
    // 监听bus中介上面的自定义事件collapse
    bus.$on('collapse', col => {
      this.isCollapse = col
    })
    // 用户点击了上面的tab 菜单组件需要做响应的切换
    bus.$on('layoutTabChange', tag => {
      this.active = tag.fullPath
      this.$router.push({
        path: tag.path,
        query: tag.query
      })
    })

    bus.$on('setActiveTab', tag => {
      this.active = tag.fullPath
    })
  },
  beforeDestroy () {
    bus.$off('collapse')
    bus.$off('layoutTabChange')
    bus.$off('setActiveTab')
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.minbox {
  position: relative;
}

.minbox::-webkit-scrollbar {
  display: none;
}

.tools {
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  height: 46px;
  background-color: $blue5;
  color: pink;

  img {
    margin-top: 10px;
    width: 200px;
  }
}

::v-deep .el-menu-item {
  color: #304e72 !important;
  padding-left: 50px !important;
  // background-color:$yellow !important;
}

// 菜单选中时的背景颜色
::v-deep .el-menu-item.is-active {
  color: #fcfcfc !important;
  background-color: var(--primary-color) !important;
}

::v-deep .el-menu-item:hover {
  color: #fcfcfc !important;
  background: var(--primary-color) !important;
}

::v-deep .el-submenu__title i {
  color: #ffffff;
  font-size: 16px;
  margin-right: 5px;
  width: 24px;
}

// ::v-deep.el-submenu__title i:hover {
//   color: #fcfcfc !important;
// }
::v-deep .el-submenu__title:hover {
  color: #fff !important;
  background: var(--primary-color) !important;

  span {
    color: #fff !important;
  }

  i {
    // background-color: var(--primary-color) !important;
    color: #fff !important;
    background: rgba(255, 255, 255, 0) !important;
  }

  // i:before {
  //   background: var(--primary-color) !important;
  // }
}

::v-deep .el-submenu__title i {
  color: #304e72;
}

::v-deep .el-submenu__title span {
  color: #383838;
  font-size: 14px;
}

::v-deep .el-menu--collapse {
  width: 40px;
}

// /*隐藏文字*/
::v-deep .el-menu--collapse .el-submenu__title {
  padding-left: 8px !important;
}

::v-deep .el-menu--collapse .el-submenu__title span {
  display: none;
}

// 正常状态下
::v-deep .el-menu--collapse .el-submenu__title {
  i {
    font-size: 20px;
    color: var(--primary-color);
    background-color: #f3f3f3;
  }

  span {
    font-size: 16px;
  }

  .el-submenu__icon-arrow {
    display: none;
  }
}

.l_menu:not(.el-menu--collapse) {
  width: 250px;
}
</style>
